export default __webpack_public_path__ + "static/media/app_stores.a7c8ca28.png";